import { assert } from '@/utils/assert';
import { pascalCase } from '@/utils/case';

// This gives every route component a base mounted hook which declares that it
// wants the default app header. This can be overridden by redefining the
// `setupHeaderContext` function inside the component and dispatching a new
// header context.
export default function (Vue) {
  const routeComponentNames = new Set(process.env.ROUTE_COMPONENT_NAMES);

  Vue.mixin({
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        if (vm.isRouteComponent) vm.setupHeaderContext();
      });
    },

    computed: {
      isRouteComponent() {
        // The top level app component can be ignored.
        if (this.constructor === Vue) {
          return false;
        }

        // Only consider leaf node route components.
        if (this.$children.some((a) => a.isRouteComponent)) {
          return false;
        }

        assert(
          !!this.$options.name,
          `Component ${
            this.$options.__file || this.$options._componentTag
          } has no name`,
          { warn: true }
        );

        return routeComponentNames.has(pascalCase(this.$options.name));
      },
    },

    methods: {
      setupHeaderContext() {
        this.$store.dispatch('setHeaderContext', {
          componentName: 'HeaderNavDefault',
        });
      },
    },
  });
}
